import React, { useEffect, useState } from 'react';
import { Shield, AlertTriangle, RefreshCw } from 'lucide-react';

interface FirefoxAdFallbackProps {
  size: 'desktop' | 'mobile';
  className?: string;
}

export const FirefoxAdFallback: React.FC<FirefoxAdFallbackProps> = ({ 
  size, 
  className = '' 
}) => {
  const [showInstructions, setShowInstructions] = useState(false);
  const isDesktop = size === 'desktop';

  const handleRefresh = () => {
    window.location.reload();
  };

  if (isDesktop) {
    return (
      <div className={`bg-gradient-to-br from-orange-50 to-red-50 dark:from-orange-900/20 dark:to-red-900/20 border border-orange-200 dark:border-orange-800 rounded-lg p-4 ${className}`}>
        <div className="text-center">
          <div className="flex justify-center mb-2">
            <Shield className="w-5 h-5 text-orange-600 dark:text-orange-400" />
          </div>
          <h4 className="text-sm font-semibold text-orange-800 dark:text-orange-200 mb-2">
            Firefox Enhanced Protection Active
          </h4>
          <p className="text-xs text-orange-700 dark:text-orange-300 mb-3">
            Firefox is blocking ads to protect your privacy
          </p>
          
          <button
            onClick={() => setShowInstructions(!showInstructions)}
            className="text-xs text-orange-600 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-200 underline mb-2"
          >
            {showInstructions ? 'Hide' : 'Show'} instructions
          </button>
          
          {showInstructions && (
            <div className="text-xs text-orange-600 dark:text-orange-400 bg-orange-100 dark:bg-orange-900/30 rounded p-2 mb-2">
              <p className="mb-1">To see ads in Firefox:</p>
              <p className="mb-1">1. Click the shield icon in address bar</p>
              <p className="mb-1">2. Turn off "Enhanced Tracking Protection"</p>
              <p>3. Refresh this page</p>
            </div>
          )}
          
          <button
            onClick={handleRefresh}
            className="inline-flex items-center gap-1 text-xs text-orange-600 dark:text-orange-400 hover:text-orange-800 dark:hover:text-orange-200 transition-colors"
          >
            <RefreshCw className="w-3 h-3" />
            Refresh Page
          </button>
        </div>
      </div>
    );
  }

  // Mobile fallback
  return (
    <div className={`bg-gradient-to-r from-orange-50 to-red-50 dark:from-orange-900/20 dark:to-red-900/20 border-t border-orange-200 dark:border-orange-800 p-3 ${className}`}>
      <div className="flex items-center justify-center gap-2 mb-1">
        <Shield className="w-4 h-4 text-orange-600 dark:text-orange-400" />
        <span className="text-sm text-orange-600 dark:text-orange-400 font-medium">
          Firefox Protection Active
        </span>
      </div>
      <p className="text-xs text-center text-orange-600 dark:text-orange-400">
        Disable Enhanced Tracking Protection to see ads
      </p>
    </div>
  );
};

export default FirefoxAdFallback;
